// Wait for the window to fully load before initializing
window.addEventListener('load', () => {
  const themeCardsBlocks = document.querySelectorAll('.theme-cards');
  
  if (themeCardsBlocks.length) {
    // Initialize block-specific functionality here
  }
});
